import { DocumentModel } from '../../model/document.model';

export const initialState = {
  loading: false,
  isLoading: false,
  documentList: null,
  uploadDocuments: null,
  documentModel: new DocumentModel(),
  PaperDocument: null,
  page: 1,
};

export type DocumentState = Readonly<typeof initialState>;
